import { render, staticRenderFns } from "./PriorityModal.vue?vue&type=template&id=39b4f74c"
import script from "./PriorityModal.vue?vue&type=script&lang=js"
export * from "./PriorityModal.vue?vue&type=script&lang=js"
import style0 from "./PriorityModal.vue?vue&type=style&index=0&id=39b4f74c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports